import {useEffect, useRef} from 'react'
import {Tab} from 'bootstrap'
import { MenuComponent } from '../assets/ts/components/MenuComponent'
import { ScrollComponent } from '../assets/ts/components/ScrollComponent'
import { useLayout } from './core/LayoutProvider'
import { ToggleComponent } from '../assets/ts/components/ToggleComponent'

const MasterInit = () => {
    const {config} = useLayout()
    const isFirstRun = useRef(true)
    const pluginsInitialization = () => {
        isFirstRun.current = false
        setTimeout(() => {
            ToggleComponent.bootstrap()
            MenuComponent.bootstrap()
            ScrollComponent.bootstrap()
            document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
                Tab.getOrCreateInstance(tab)
            })
        }, 500)
    }

    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false
            pluginsInitialization()
        }
    }, [config])

    return <></>
}

export default MasterInit